import { useEffect, useState } from 'react';
import { LoginButton } from './loginButton/LoginButton';
import { Dropdown } from './dropdown/Dropdown';
import { NavItem } from './navItem/NavItem';

import './Navbar.css';


export const Navbar = () => {

    const [click, setClick] = useState(false);
    const [width, setWidth] = useState({winWidth: window.innerWidth});


    // adaptation navbar burger menu
    const detectSize = () => {
        setWidth({winWidth: window.innerWidth})
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        return () => {
            window.removeEventListener('resize', detectSize)
        }
    }, [width])
    

    //to change burger classes
    const [burgerClass, setBurgerClass] = useState('burger-bar unclicked');
    const [menuClass, setMenuClass] = useState('menu hidden');
    const [isMenuClicked, setIsMenuClicked] = useState(false);

    //toggle burger menu change
    const updateMenu = () => {
        if (!isMenuClicked) {
            setBurgerClass('burger-bar clicked')
            setMenuClass('menu visible')
        } else {
            setBurgerClass('burger-bar unclicked')
            setMenuClass('menu hidden')
        }
        setIsMenuClicked(!isMenuClicked)
    }

    return (
        <>
            <nav className="navbar">
                {(width.winWidth >= 1270) ?
                    <div className="nav-container">
                        <ul className={click ? "nav-menu active" : "nav-menu"}>
                            <NavItem link={'/promotions'} name={'Акції'} />
                            <NavItem link={'/sets'} name={'Сети'} />
                            <NavItem link={'/rolls'} name={'Роли'} />
                            <NavItem link={'/premium'} name={'Преміум-меню'} />
                            <NavItem link={'/combo'} name={'Комбо-меню'} />
                            <NavItem link={'/pizza'} name={'Піца'} />
                            <NavItem link={'/pizza_toppings'} name={'Добавки до піци'} />
                            <NavItem link={'/salads'} name={'Салати'} />
                            <NavItem link={'/gunkan_nigiri'} name={'Гункани та нігірі'} />
                            <NavItem link={'/drinks'} name={'Напої'} />
                        </ul>
                    </div>
                    :
                    <div className='burgerMenu-container'>
                        <div className='burgerMenu' onClick={updateMenu}>
                            <div className={burgerClass}></div>
                            <div className={burgerClass}></div>
                            <div className={burgerClass}></div>
                        </div>
                    </div>
                }

                {/* <LoginButton /> */}
            </nav>

            <div className={menuClass} onClick={updateMenu}>
                <NavItem link={'/promotions'} name={'Акції'} />
                <NavItem link={'/sets'} name={'Сети'} />
                <NavItem link={'/rolls'} name={'Роли'} />
                <NavItem link={'/premium'} name={'Преміум-меню'} />
                <NavItem link={'/combo'} name={'Комбо-меню'} />
                <NavItem link={'/pizza'} name={'Піца'} />
                <NavItem link={'/pizza_toppings'} name={'Добавки до піци'} />
                <NavItem link={'/salads'} name={'Салати'} />
                <NavItem link={'/gunkan_nigiri'} name={'Гункани та нігірі'} />
                <NavItem link={'/drinks'} name={'Напої'} />
            </div>
        </>
    );
}